export const getMimetype = (signature: string) => {
    switch (signature) {
        case "89504E47":
            return "image/png";
        case "47494638":
            return "image/gif";
        case "25504446":
            return "application/pdf";
        case "FFD8FFDB":
        case "FFD8FFE0":
        case "FFD8FFE1":
            return "image/jpeg";
        case "504B0304":
            return "application/zip";
        case "676C5446":
            return "model/gltf-binary";
        case "7B226578":
            return "model/gltf+json";
        default:
            return "Unknown filetype";
    }
};

export const getContentType = async (src: string): Promise<string> => {
    const res = await fetch(src, { method: "GET" }).then((response) => {
        const mime = response.headers.get("Content-type");
        if (mime) {
            return mime;
        }

        return response.blob().then((blob) => {
            const reader = new FileReader();
            const mimePromise = new Promise<string>((resolve, reject) => {
                reader.onload = function (e) {
                    const uint = new Uint8Array(e.target!.result?.slice(0, 4) as ArrayBufferLike);
                    const bytes: string[] = [];
                    uint.forEach((byte) => {
                        bytes.push(byte.toString(16));
                    });
                    const hex = bytes.join("").toUpperCase();
                    return resolve(getMimetype(hex));
                };
                reader.onerror = function () {
                    reject(reader.error);
                };
            });
            reader.readAsArrayBuffer(blob);

            return mimePromise;
        });
    });
    return res ? res : "";
};
